/** Customer-facing business name. Copy uses `{brand}` so the name is not repeated as a literal. */
export const BRAND_NAME = 'NextCompli';

export const withBrand = (template: string): string => template.replaceAll('{brand}', BRAND_NAME);
